import { Sparkle } from 'lucide-react';

import { useCopilotComposer } from '@/features/copilot/lib';
import { Button } from '@/shared/ui/shadcn/button';

import { CORTEX_PROMPTS, type CortexPrompt } from '../model';

function CortexPromptChip({ prompt }: { prompt: CortexPrompt }) {
  const { sendText } = useCopilotComposer();

  const handleClick = () => {
    sendText({ text: prompt.text, source: prompt.source });
  };

  return (
    <Button
      type="button"
      variant="chip"
      size="chip"
      radius="pill"
      onClick={handleClick}
      className="gap-1.5 border-foreground/20 bg-transparent text-foreground hover:bg-secondary/40 hover:text-foreground"
    >
      <Sparkle className="size-4" aria-hidden="true" />
      <span>{prompt.label}</span>
    </Button>
  );
}

export function CortexPromptStrip() {
  return (
    <div
      role="list"
      aria-label="Suggested prompts"
      className="flex gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {CORTEX_PROMPTS.map((prompt) => (
        <div key={prompt.id} role="listitem" className="shrink-0">
          <CortexPromptChip prompt={prompt} />
        </div>
      ))}
    </div>
  );
}
